export const LAUNCH_EVENT = {
  date: "03 June 2026",
  dateShort: "03-06-2026",
  day: "Wednesday",
  time: "10:00 AM onwards",
  venue: "Hotel Regalia",
  address: "Ramanuja Circle, Renugunta Road, Tirupathi",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Hotel+Regalia+Ramanuja+Circle+Renugunta+Road+Tirupathi",
  status: "completed",
};

export const LAUNCH_HIGHLIGHTS = [
  {
    title: "Rudra Ride",
    desc: "Smart mobility platform officially unveiled to the public.",
    link: "/rudra-rides",
    accent: "#26A9B5",
  },
  {
    title: "Edu Pravahaa",
    desc: "Digital education & LMS platform introduced with industry programs.",
    link: "/edupravahaa",
    accent: "#2563EB",
  },
];

export const LAUNCH_MILESTONES = [
  { step: "01", label: "Grand Launch", detail: "03 June 2026 · Tirupathi" },
  { step: "02", label: "Platforms Live", detail: "Rudra Ride & Edu Pravahaa" },
  { step: "03", label: "Now Open", detail: "Enrollments & partnerships" },
];

export const LAUNCH_GUESTS = [
  "Special Guests",
  "Media Members",
  "Auto Union Leaders",
  "Local Leaders",
  "Business Guests",
];
